import { ChangeDetectionStrategy, Component, InputSignal, OutputEmitterRef, input, output } from '@angular/core';

import { EntityItemActionButtonComponent } from '@core/ui';

@Component({
  selector: 'mp-remove-button',
  template: `<mp-entity-item-action-button [icon]="isRemoved() ? 'undo' : 'close'" (actionClick)="emitRemoved()" />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [EntityItemActionButtonComponent],
})
export class RemoveButtonComponent {
  readonly isRemoved: InputSignal<boolean> = input<boolean>(false);
  readonly clicked: OutputEmitterRef<void> = output<void>();

  emitRemoved(): void {
    this.clicked.emit();
  }
}
